import React, { useEffect, useState } from "react";
import { CheckCircle, X } from "lucide-react";
import { dataTrigger } from "@/analytics";
import { Button } from "@/ui/Button/Button";
import cls from "./styles.module.scss";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type Particle = {
  id: number;
  x: number;
  y: number;
  rotation: number;
  delay: number;
  duration: number;
};

export function SuccessModal({ isOpen, onClose }: SuccessModalProps) {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    if (!isOpen) return;

    const next = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: -20,
      rotation: Math.random() * 360,
      delay: Math.random() * 0.5,
      duration: 2 + Math.random(),
    }));

    setParticles(next);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={cls.root}>
      <div className={cls.backdrop} onClick={onClose} />

      <div className={cls.confettiLayer} aria-hidden>
        {particles.map((p) => (
          <div
            key={p.id}
            className={cls.confetti}
            style={
              {
                left: `${p.x}vw`,
                top: `${p.y}vh`,
                ["--rot" as any]: `${p.rotation}deg`,
                animationDelay: `${p.delay}s`,
                animationDuration: `${p.duration}s`,
              } as React.CSSProperties
            }
          />
        ))}
      </div>

      <div className={cls.modalWrap}>
        <div className={cls.modal}>
          <button
            className={cls.closeBtn}
            onClick={onClose}
            aria-label="Close"
            {...dataTrigger("bkn.success_modal.close")}
          >
            <X className={cls.closeIcon} />
          </button>

          <div className={cls.iconRow}>
            <div className={cls.iconWrap}>
              <div className={cls.iconBubble}>
                <CheckCircle className={cls.icon} strokeWidth={2.5} />
              </div>
              <div className={cls.iconGlow} />
            </div>
          </div>

          <h2 className={cls.heading}>Подписка оформлена!</h2>

          <p className={cls.text}>
            Спасибо за покупку! Теперь вы можете пользоваться всеми
            возможностями БКоннект.
          </p>

          <div className={cls.btnWrap}>
            <Button
              variant="primary"
              size="lg"
              onClick={onClose}
              {...dataTrigger("bkn.success_modal.ok")}
            >
              Отлично!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
